export default Object.freeze({
  Regular: 1,
  Custom: 2,
});
